// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__cWXyg","itemTitle":"ClientEmergencyInfo_itemTitle__sJsZ6","itemText":"ClientEmergencyInfo_itemText__39_Z2"};